import { TextProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TextProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TextProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      ellipsis: true,
      children: 'text',
    } as TextProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
